module.exports = __webpack_public_path__ + "static/media/user@2x.9ec6c246.png";